import { render, staticRenderFns } from "./test.vue?vue&type=template&id=e2154fec&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=e2154fec&prod&lang=css"
import style1 from "./test.vue?vue&type=style&index=1&id=e2154fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2154fec",
  null
  
)

export default component.exports